// extracted by mini-css-extract-plugin
module.exports = {"storyParentWrapper":"story_storyParentWrapper__h6DRG","storyWrapper":"story_storyWrapper__ywbnJ"};